export interface FieldConfig {
    key: string
    label: string
}

export interface TabConfig {
    id: string
    label: string
    description: string
    fields: FieldConfig[]
}

const tabsConfig: TabConfig[] = [
    {
        id: "alerteVehicule",
        label: "Alertes véhicule",
        description: "Permet le paramétrage du type par défaut du lead créé lors d'une alerte véhicule",
        fields: [
            { key: "alerteVehiculeVN",  label: "VN"  },
            { key: "alerteVehiculeVO",  label: "VO"  },
            { key: "alerteVehiculeVDL", label: "VDL" },
        ],
    },
    // Pour ajouter un onglet, dupliquer le bloc ci-dessus :
    {
        id: "interfaces",
        label: "Interfaces",
        description: "Permet le paramétrage du type par défaut du lead créé lors de la création d'une offre avec une interface externe",
        fields: [
            { key: "wafy", label: "Bee2Link Wafy" },
            { key: "openflex", label: "Bee2Link Openflex" },
            { key: "pvo2", label: "Planet VO2" }
        ],
    },
]

export default tabsConfig
